import styled from "styled-components";

export const FeedbackText = styled.h2`
    color:${props => props.theme.colors.white} ;
    text-align:center ;
    margin:20px 0 ;
`;